import { GetUser } from '../queries/user';

const user = {
  defaults: {
    user: {
      __typename: 'User',
      userId: '',
      loggedIn: false,
      email: '',
      phone: '',
    },
  },
  resolvers: {
    Mutation: {
      updateUser: (
        _: any,
        {
          userId,
          loggedIn,
          email,
          phone,
        }: { userId: string; loggedIn: boolean; email: string; phone: string },
        { cache }: { cache: any },
      ) => {
        console.log('updateUser', userId, loggedIn, email, phone);
        const user = {
          __typename: 'User',
          userId,
          loggedIn,
          email,
          phone,
        };
        cache.writeData({ query: GetUser, data: { user } });
        console.log('cache', cache);
        return user;
      },
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/resolvers/user.tsx